import { ASSIGN_SENSOR_FORM_INITIAL_VALUES } from './constant';
import {
  SVG_SENSOR_ICON_ORIGINAL_HEIGHT,
  SVG_SENSOR_ICON_ORIGINAL_WIDTH,
} from '../../../utilities/image-utils';

export const buildInitialValues = (
  sensors,
  siteId,
  floorId,
  layerId,
  zoneId
) => {
  if (sensors?.length > 0) {
    const availableSensors = sensors.map((sensor) => {
      const { id, latitude, longitude } = sensor || {};
      return {
        id: parseInt(id),
        latitude: parseInt(latitude),
        longitude: parseInt(longitude),
      };
    });
    return { siteId, floorId, layerId, zoneId, sensors: availableSensors };
  } else {
    return ASSIGN_SENSOR_FORM_INITIAL_VALUES;
  }
};

export const sensorScaleDownTransform = (
  sensors = [],
  widthScale,
  heightScale,
  naturalWidth,
  naturalHeight
) => {
  return sensors.map((sensor) => {
    const {
      id,
      latitude,
      longitude,
      direction,
      name,
      nameShort,
      type,
      sensorId,
    } = sensor || {};
    const lat = parseInt(latitude || 0);
    const lng = parseInt(longitude || 0);

    const sanitizedLat = lat > naturalWidth || lat < 0 ? 0 : lat;
    const sanitizedLng = lng > naturalHeight || lng < 0 ? 0 : lng;
    return {
      id: parseInt(id),
      sensorId,
      latitude: widthScale(sanitizedLat),
      longitude: heightScale(sanitizedLng),
      direction,
      name: nameShort,
      type,
      color: '#2db34a',
    };
  });
};
export const heatMapDateScaleDownTransform = (
  heatMapDate = [],
  widthScale,
  heightScale,
  naturalWidth,
  naturalHeight
) => {
  return heatMapDate.map((item) => {
    const { name, x, y, value, radius } = item || {};
    const lat = parseInt(x || 0) + parseInt(SVG_SENSOR_ICON_ORIGINAL_WIDTH / 2); // Delta values are added to push circle center to arrow center
    const lng =
      parseInt(y || 0) + parseInt(SVG_SENSOR_ICON_ORIGINAL_HEIGHT / 2);

    const sanitizedLat = lat > naturalWidth || lat < 0 ? 0 : lat;
    const sanitizedLng = lng > naturalHeight || lng < 0 ? 0 : lng;
    return {
      name,
      x: widthScale(sanitizedLat),
      y: heightScale(sanitizedLng),
      value,
      radius,
    };
  });
};
